import React, { useEffect } from 'react';

import QCXFormStepWizard from '../../shared-components/form-step-wizard/QCXFormStepWizard';
import QCXSelectManyServicosTable from './QCXSelectManyServicosTable';

export default function QCXSelectManyServicosFinalFormTable({
  list = [],
  isConsult,
  title,
  filterProp,
  filterPropGetter,
  columns,
  handleSubmit,
  handleChange,
  controlComponentProps,
  ...restProps
}) {
  
  return (
    <QCXFormStepWizard
      onSubmit={handleSubmit}
      controlComponentProps={controlComponentProps}
      {...restProps}
    >
      {() => (
        <QCXSelectManyServicosTable
          title={title}
          columns={columns}
          filterProp={filterProp}
          selected={list}
          isConsult={isConsult}
          handleChange={handleChange}
        />
      )}
    </QCXFormStepWizard>
  );
}
